import type { JSX } from 'react';
import { ContrastIndicator } from './ContrastIndicator';
import { ContrastEnforcerSwitch } from './ContrastEnforcerSwitch';
import { ContrastPreview } from './ContrastPreview';
import { Box } from '../Box';
import { Stack } from '../Stack';

export type ContrastControlsProps = object;

/**
 * Displays a preview of the selected color against the comparison color, the
 * WCAG contrast ratio, and a toggle switch for enforcing minimum contrast.
 * Relies on `colorForComparison` and `minimumContrastRatio` set on the parent
 * `ColorPicker`.
 */
export const ContrastControls = (props: ContrastControlsProps): JSX.Element => {
  return (
    <Stack {...props}>
      <Box
        alignItems="center"
        direction="row"
        justifyContent="space-between"
      >
        <ContrastPreview />
        <ContrastIndicator />
      </Box>
      <ContrastEnforcerSwitch />
    </Stack>
  );
};

ContrastControls.displayName = 'ContrastControls';
